import { FC, ReactNode } from 'react';

import classNames from 'classnames';

import 'components/Table/TableHeadCell/TableHeadCell.less';

export enum TableHeadCellKind {
    Basic = 'basic',
    Amount = 'amount',
    Normal = 'normal',
}

interface TableHeadCellProps {
    children?: ReactNode;
    kind?: TableHeadCellKind;
    className?: string;
    dataQa?: string;
    onClick?: () => void;
}

const TableHeadCell: FC<TableHeadCellProps> = ({ children, kind, className = '', dataQa, ...props }) => (
    <th
        className={classNames('table-head-cell', kind ? `table-head-cell_${kind}` : '', className)}
        data-qa={dataQa}
        {...props}
    >
        {children}
    </th>
);

TableHeadCell.defaultProps = {
    kind: TableHeadCellKind.Basic,
};

export default TableHeadCell;
